/**
 * Trạng Process
 */
export default {
    /**
     * Đang xử lý
     */
    Process: 5,
    /**
     * Thành công
     */
    Success: 10,
    /**
     * THất bại
     */
    Fail: 15,
    /**
     * Cảnh báo
     */
    Warning: 20,

};
